import DOMPurify from 'dompurify';

interface SecureContentRendererProps {
  content: string;
  className?: string;
  allowedTags?: string[];
  allowedAttributes?: string[];
}

export const SecureContentRenderer = ({ 
  content, 
  className = '',
  allowedTags = [
    'p', 'br', 'strong', 'em', 'u', 's', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'ul', 'ol', 'li', 'blockquote', 'a', 'span', 'div'
  ],
  allowedAttributes = ['href', 'target', 'rel', 'class', 'style']
}: SecureContentRendererProps) => {
  const createSafeHTML = (htmlContent: string) => {
    const cleanHTML = DOMPurify.sanitize(htmlContent, {
      ALLOWED_TAGS: allowedTags,
      ALLOWED_ATTR: allowedAttributes,
      ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
      ADD_ATTR: ['target'],
      FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover'],
      FORBID_TAGS: ['script', 'object', 'embed', 'form', 'input', 'textarea', 'select', 'option'],
      KEEP_CONTENT: true,
      RETURN_DOM: false,
      RETURN_DOM_FRAGMENT: false,
      RETURN_TRUSTED_TYPE: false
    });

    // Additional security: ensure external links open in new tab and have security attributes
    return cleanHTML.replace(
      /<a\s+([^>]*href=["'](?:https?:\/\/|\/\/)[^"']*["'][^>]*)>/gi,
      '<a $1 target="_blank" rel="noopener noreferrer">'
    );
  };

  const sanitizedContent = createSafeHTML(content);

  return (
    <div 
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitizedContent }}
    />
  );
};